<div class="tab-divider"></div>

<div class="container my-4">
  <div class="row g-3">
    <div class="w-100 button-row">
      <span class="header-8"
        >Total Number of Test Cases : {{ data?.dataSet.length }}</span
      >
      <button class="btn  btn-accello-primary" (click)="downloadCSV()">
        Download CSV
      </button>
    </div>
    <div class="col-12 col-sm-6 col-lg-3" *ngFor="let item of data?.dataSet">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex">
            <h5 class="card-title header-7 flex-grow-1">{{ item.id }}</h5>
            <app-icon
              icon="open_with"
              (click)="moreDetails(item)"
              (keydown.enter)="moreDetails(item)"
              [customStyle]="{
                fontSize: '14px',
                color: '#97C382',
                cursor: 'pointer'
              }"
            ></app-icon>
          </div>
          <p class="card-text general-text-2">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
